// extracted by mini-css-extract-plugin
export default {"account-row":"BrandAccount_account-row__FGpQa","button-width":"BrandAccount_button-width__+jVDb"};